(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tpg-package-grid"] && !Shopify.designMode) return;
  try {
    (function () {
  // Public copy carries no package or component prices. Product identity and
  // level selection are preserved; final pricing is confirmed in the quote.
  var TPG_COMPONENTS = {
    entry: {
      tee: { adult: 'Gildan 8000 DryBlend (8000)', youth: 'Gildan 8000B Youth' },
      short: { adult: 'Sport-Tek ST349', youth: 'Sport-Tek YST355 Youth' },
      crew: { adult: 'Port & Co PC90', youth: 'Port & Co PC90Y Youth' },
      hoodie: { adult: 'Port & Co PC90H', youth: 'Port & Co PC90YH Youth' },
      jogger: { adult: 'Gildan 18200', youth: 'Gildan 18200B Youth' }
    },
    preferred: {
      tee: { adult: 'District Perfect Tri Tee (DM130)', youth: 'District DT130Y Youth' },
      short: { adult: 'Sport-Tek ST349P', youth: 'Sport-Tek YST355P Youth' },
      crew: { adult: 'District V.I.T. Fleece Crew (DT6104)', youth: 'District DT6104Y Youth' },
      hoodie: { adult: 'District V.I.T. Fleece Hoodie (DT6100)', youth: 'District DT6100Y Youth' },
      jogger: { adult: 'Jerzees IC50M Pocket Jogger', youth: 'District DT6112Y Youth' }
    },
    'brand-name': {
      tee: { adult: 'Nike Legend Tee (NKBQ5231)', youth: '' },
      short: { adult: 'Sport-Tek ST442 Performance Short', youth: '' },
      crew: { adult: 'Nike Club Fleece Crew (NKFD9863)', youth: '' },
      hoodie: { adult: 'Nike Club Fleece Hoodie (NKDR1499)', youth: '' },
      jogger: { adult: 'Nike Club Fleece Jogger (NKHM8045)', youth: '' }
    }
  };
  // Approved public component contributions per player, indexed by the four
  // displayed bands (12–23, 24–35, 36–47, 48+). They reconcile to the published
  // homogeneous package prices and expose no supplier cost or margin.
  var TPG_COMPONENT_PRICES = {
    entry: { tee:[15,14,13,13], short:[15,13,13,12], crew:[25,23,23,23], hoodie:[35,33,33,32], jogger:[30,25,25,24] },
    preferred: { tee:[18,16,16,15], short:[17,16,15,15], crew:[25,23,23,22], hoodie:[30,27,27,26], jogger:[35,30,29,29] },
    'brand-name': { tee:[33,30,30,29], short:[32,30,29,28], crew:[70,65,64,63], hoodie:[80,75,74,73], jogger:[70,65,63,62] }
  };
  function tpgComponentPrice(packageKey, parts, selectedLevels, tierIndex) {
    var price = parts.reduce(function (total, part) {
      return total + TPG_COMPONENT_PRICES[selectedLevels[part]][part][tierIndex];
    }, 0);
    if (packageKey === 'podium-hoodie-package') {
      var adjustments = { entry:[0,0,-1,0], preferred:[0,0,0,1], 'brand-name':[0,0,0,-1] };
      price += adjustments[selectedLevels.hoodie][tierIndex];
    }
    return Math.round(price);
  }
  var TPG_LEVEL_LABELS = { entry:'Entry', preferred:'Preferred', 'brand-name':'Brand Name' };
  var TPG_PART_LABELS = { tee:'Practice tee', short:'Practice short', crew:'Crewneck', hoodie:'Hoodie', jogger:'Jogger' };

  function initTpgPackageBuilders(root) {
    root.querySelectorAll('[data-tpg-package-builder]').forEach(function (selector) {
      if (selector.dataset.tpgPackageReady === 'true') return;
      selector.dataset.tpgPackageReady = 'true';

      var parts = selector.dataset.parts.split('|');
      var selectedLevels = {};
      parts.forEach(function (part) { selectedLevels[part] = 'entry'; });
      var status = selector.querySelector('[data-tpg-builder-status]');

      function selectedProducts() {
        return parts.map(function (part) {
          return TPG_PART_LABELS[part] + ': ' + TPG_COMPONENTS[selectedLevels[part]][part].adult;
        });
      }

      function renderSelection() {
        selector.querySelectorAll('[data-tpg-price-tier]').forEach(function (tile) {
          var price = tpgComponentPrice(selector.dataset.package, parts, selectedLevels, Number(tile.dataset.tierIndex));
          var value = tile.querySelector('[data-tpg-price-value]');
          if (value) value.textContent = '$' + price;
          tile.setAttribute('aria-label', tile.querySelector('small').textContent + ', starting at $' + price + ' per player. Choose sizing and request a quote.');
        });
        parts.forEach(function (part) {
          var component = selector.querySelector('[data-tpg-component="' + part + '"]');
          if (!component) return;
          component.querySelectorAll('[data-tpg-component-level]').forEach(function (button) {
            var active = button.dataset.tpgComponentLevel === selectedLevels[part];
            button.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          var product = TPG_COMPONENTS[selectedLevels[part]][part];
          var levelLabel = component.querySelector('[data-tpg-component-level-label]');
          if (levelLabel) levelLabel.textContent = TPG_LEVEL_LABELS[selectedLevels[part]];
          var productEl = component.querySelector('[data-tpg-component-product]');
          if (productEl) {
            productEl.replaceChildren();
            var adult = document.createElement('strong');
            adult.textContent = 'Adult: ' + product.adult;
            productEl.appendChild(adult);
            var youth = document.createElement('span');
            youth.textContent = product.youth ? 'Youth: ' + product.youth : 'Youth: unavailable — request an assisted quote for an exact governed equivalent.';
            productEl.appendChild(document.createElement('br'));
            productEl.appendChild(youth);
          }
          var thumbnail = component.querySelector('[data-tpg-component-thumbnail]');
          if (thumbnail) {
            var sourceKey = selectedLevels[part] === 'brand-name' ? 'brandNameSrc' : selectedLevels[part] + 'Src';
            var productSource = thumbnail.dataset[sourceKey];
            var source = productSource || thumbnail.dataset.fallbackSrc;
            var usesFallback = !productSource;
            if (source && thumbnail.dataset.currentSource !== source) {
              thumbnail.dataset.currentSource = source;
              thumbnail.hidden = false;
              thumbnail.closest('.tpg-level-selector__thumbnail')?.classList.remove('is-missing');
              thumbnail.src = source;
            }
            thumbnail.dataset.tpgFallbackApplied = usesFallback ? 'true' : 'false';
            thumbnail.classList.toggle('is-fallback', usesFallback);
            thumbnail.alt = usesFallback
              ? 'Product photo unavailable for ' + product.adult + '; ' + TPG_PART_LABELS[part].toLowerCase() + ' category illustration'
              : TPG_PART_LABELS[part] + ': ' + product.adult + ', ' + TPG_LEVEL_LABELS[selectedLevels[part]] + ' level';
          }
        });

        if (status) status.textContent = selector.dataset.selectedLabel + ' ' + selectedProducts().join(' · ');
      }

      selector.querySelectorAll('[data-tpg-component-level]').forEach(function (button) {
        button.addEventListener('click', function () {
          var component = button.closest('[data-tpg-component]');
          if (!component) return;
          selectedLevels[component.dataset.tpgComponent] = button.dataset.tpgComponentLevel;
          renderSelection();
        });
      });

      selector.querySelectorAll('[data-tpg-component-thumbnail]').forEach(function (thumbnail) {
        thumbnail.addEventListener('error', function () {
          var frame = thumbnail.closest('.tpg-level-selector__thumbnail');
          if (thumbnail.dataset.tpgFallbackApplied === 'true') {
            thumbnail.hidden = true;
            frame?.classList.add('is-missing');
            return;
          }
          thumbnail.dataset.tpgFallbackApplied = 'true';
          thumbnail.dataset.currentSource = thumbnail.dataset.fallbackSrc;
          thumbnail.classList.add('is-fallback');
          thumbnail.src = thumbnail.dataset.fallbackSrc;
        });
      });

      selector.querySelectorAll('[data-tpg-quantity-tier]').forEach(function (tile) {
        tile.addEventListener('click', function () {
          var componentQuery = parts.map(function (part) { return part + ':' + selectedLevels[part]; }).join(',');
          var uniqueLevels = Array.from(new Set(parts.map(function (part) { return selectedLevels[part]; })));
          var query = new URLSearchParams({
            project: 'practice-gear', sport: selector.dataset.sport || 'Team', package: selector.dataset.package,
            level: uniqueLevels.length === 1 ? uniqueLevels[0] : 'mixed', components: componentQuery,
            quantity: tile.dataset.quantityTier, sizing: '1', step: '0'
          });
          var fullUrl = '/pages/request-a-quote?' + query.toString();
          /* Short path first: prefill the on-page quick request and scroll to it.
             The full sizing wizard stays one link away inside that form. */
          if (typeof window.tpgQuickRequestPrefill === 'function' && document.querySelector('[data-tpg-quick-request]')) {
            var priceEl = tile.querySelector('[data-tpg-price-value]');
            window.tpgQuickRequestPrefill({
              package: selector.dataset.package, quantity: tile.dataset.quantityTier,
              level: uniqueLevels.length === 1 ? uniqueLevels[0] : 'mixed',
              price: priceEl ? priceEl.textContent.replace(/[^0-9.]/g, '') : '',
              fullUrl: fullUrl
            });
            return;
          }
          window.location.assign(fullUrl);
        });
      });

      renderSelection();
    });
  }

  function start() { initTpgPackageBuilders(document); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initTpgPackageBuilders(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
